<template>
    <main class="hk-notice">
        <div class="hk-notice-container flex flex-vertical-center">
            <h3 class="has-lesson flex flex-vertical-center">
                <img src="@images/base/notice-icon.png" alt="" />
                <span>今日{{ userInfo.today ? '有' : '无' }}课</span>
            </h3>
            <p class="lesson-count">已预约直播课{{ userInfo.total }}节</p>
        </div>
    </main>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'HkNotice',
    data() {
        return {};
    },
    computed: {
        ...mapGetters(['userInfo'])
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.hk-notice {
    box-sizing: border-box;
    width: 100%;
    height: 55px;
    padding: 18px 0 10px 40px;
    border-bottom: 1px solid #e5e5e5;
    &-container {
        .has-lesson {
            margin-right: 10px;
            img {
                margin-right: 10px;
            }
            span {
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 800;
                color: #333;
            }
        }
        .lesson-count {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #333;
            margin-top: 6px;
        }
    }
}
</style>
